import { Component, HostListener, TemplateRef } from '@angular/core';
import { faEllipsisV, faEarthAsia, faSearch, faBars, faEdit, faL } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserGroupService } from 'src/app/core/services/user-group/user-group.service';
import { RepoGksService } from 'src/app/core/services/admin-repo-gks/repo-gks.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, of } from 'rxjs';
@Component({
    selector: 'app-admin-gks',
    templateUrl: './admin-gks.component.html',
    styleUrls: ['./admin-gks.component.scss'],
})
export class AdminGksComponent {
    knowledgeStores: any;
    isLoadingData = true;
    faEllipsisV = faEllipsisV;
    searchSite = '';
    activePopupIndex: number | null = null;
    activeAccessList: number | null = null;
    currentPage = 1;
    totalItems: any;
    itemsPerPage = 10;
    isMobile = false;
    disableForm = false;
    gksnametextbox = '';
    descriptionText = '';
    errors: { [key: string]: string } = {};
    selectedUserGroup: any;
    selectedUgCountText = '#count# User group(s) Selected';
    selectedUgBlankText = 'Select';
    options: any;
    idText = '';
    pageNumber = {
        page: 1,
    };
    totalPages: any; // Total pages
    selectedGksIds: any;
    idToSend: any;
    editListofUserGroup: any;
    gksType: any;

    constructor(
        private modalService: NgbModal,
        private usergroup: UserGroupService,
        private reposervice: RepoGksService,
        private toast: ToastrService,
    ) {}

    ngOnInit() {
        this.editListofUserGroup = [];
        this.checkWidth();
        this.SearchList();
        this.displayRepoList();
        this.selectedUserGroup = [];
        this.options = [];
    }

    searchNewTerm() {
        this.pageNumber = {
            page: 1,
        };
        this.displayRepoList();
    }

    displayRepoList() {
        const offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        // const limit = this.pageNumber.page === this.totalPages ? this.totalItems - offset : this.itemsPerPage;
        const payload = {
            searchStr: this.searchSite,
            offset: offset,
            limit: 10,
        };
        this.reposervice
            .getgksList(payload)
            .pipe(
                catchError((error) => {
                    if (error.status === 400) {
                        // Handle 500 error specifically
                        this.knowledgeStores = [];
                    } else {
                        // Handle other errors
                        console.error('An error occurred:', error);
                    }
                    // Return an empty observable so the app doesn't break
                    return of(null);
                }),
            )
            .subscribe((data) => {
                if (data.data) {
                    this.isLoadingData = false;
                    this.knowledgeStores = data.data.gyanKnowledgeStores;
                    this.totalItems = data.data.totalCount;
                    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
                    this.knowledgeStores.forEach((group: { userGroups: any; access: any }) => {
                        if (group.userGroups.length > 0) {
                            group.access = group.userGroups;
                            group.userGroups = group.userGroups.map((access: any) => access.lable).join(', ');
                        } else group.userGroups = 'No user group found';
                        console.log('userGroupLables are', group.access);
                    });
                } else {
                    this.knowledgeStores = [];
                }
            });
    }

    checkWidth() {
        const width = window.innerWidth;
        console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    SearchList() {
        const reqBody = {
            clientIds: [],
            query: '',
            limit: null,
            offset: null,
            order: 'ASC',
            sortBy: 'UserGroupId',
        };

        this.usergroup.displayUsergroupList(reqBody).subscribe((data) => {
            // this.options = data.userGroups;

            this.options = [...data.userGroups];
            console.log('data.clients are', this.options);
            this.selectedUserGroup = [];
            console.log('the final options are', JSON.stringify(this.options));
        });
    }

    onSearchTextChange() {
        if (this.searchSite == '') {
            this.currentPage = 1;
            this.displayRepoList();
        }
    }

    clearSearch() {
        this.searchSite = '';
        this.currentPage = 1;
        this.displayRepoList();
    }

    togglePopup(index: number, event: Event): void {
        event.stopPropagation();
        if (this.activePopupIndex === index) {
            // Close the "Actions" popup
            this.activePopupIndex = null;
        } else {
            // Open the "Actions" popup and close the "Access" popup
            this.activePopupIndex = index;
            this.activeAccessList = null;
        }
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event): void {
        console.log('click out side is calling');
        // Close the popup if clicking outside
        this.activePopupIndex = null;
        this.activeAccessList = null;
    }

    get startItem(): number {
        return (this.currentPage - 1) * this.itemsPerPage + 1;
    }

    get endItem(): number {
        const endItem = this.currentPage * this.itemsPerPage;
        return endItem > this.totalItems ? this.totalItems : endItem;
    }

    onPageChanged(event: any) {
        this.pageNumber = event;
        this.displayRepoList();
    }

    openCreateForm(modal: TemplateRef<any>) {
        this.errors = {};
        this.descriptionText = '';
        this.idText = '';
        this.gksnametextbox = '';
        this.selectedGksIds = [];
        this.disableForm = false;
        this.selectedUserGroup = [];
        this.modalService.open(modal, { size: 'sm', windowClass: 'custom-modal-class-userGroup', backdrop: 'static', keyboard: false });
    }

    validateField(field: string) {
        switch (field) {
            case 'gksnamefield':
                this.errors[field] = this.gksnametextbox.trim() === '' ? 'Knowledge store name is required' : '';
                break;
            case 'gksidfield':
                this.errors[field] = this.idText.trim() === '' ? 'Id is required' : '';
                break;
            case 'gksdescfield':
                this.errors[field] = this.descriptionText.trim() === '' ? 'Description is required' : '';
                break;
            case 'selectedUserGroup':
                this.errors[field] = this.selectedUserGroup.length === 0 ? 'At least one usergroup must be selected' : '';
                break;
        }
    }

    onSelectionUgChange(selectedItems: Array<any>) {
        // this.selectedUserGroup = selectedItems;
        this.selectedUserGroup = [...selectedItems];
        const selectedIds = selectedItems.map((item) => item.userGroupId);
        this.selectedGksIds = selectedIds;
        console.log('the final options are', selectedIds);
    }

    createNewGKS() {
        const idObject =
            this.selectedGksIds?.length > 0
                ? this.selectedGksIds.reduce(
                      (acc: any, id: any) => {
                          acc[id] = true;
                          return acc;
                      },
                      {} as { [key: number]: boolean },
                  )
                : {};
        const payload = {
            name: this.gksnametextbox,
            recordId: this.idText,
            description: this.descriptionText,
            assignedUserGroups: idObject,
        };

        this.reposervice
            .createNewGks(payload)
            .pipe(
                catchError((error) => {
                    if (error.status === 400) {
                        // Handle 500 error specifically
                        console.error('Server error occurred:', error.error.message);
                        this.toast.warning(error.error.message);
                    } else {
                        // Handle other errors
                        console.error('An error occurred:', error);
                    }
                    // Return an empty observable so the app doesn't break
                    return of(null);
                }),
            )
            .subscribe((data) => {
                console.log('the response for creation is', data);
                if (data.code === 200) {
                    this.toast.success(data.message);
                    this.modalService.dismissAll();
                    this.currentPage = 1;
                    this.searchSite = '';
                    this.displayRepoList();
                }
                //add condition for other codes
            });
    }

    closeCreateandEditForm() {
        this.modalService.dismissAll();
    }

    restrictInput(event: KeyboardEvent): void {
        const allowedCharacters = /^[a-zA-Z0-9-_ ]*$/;
        const inputChar = event.key;

        if (!allowedCharacters.test(inputChar)) {
            event.preventDefault(); // Block the keypress
        }
    }

    isFormValid(): boolean {
        const Pattern = /[a-zA-Z0-9]/;
        return Pattern.test(this.gksnametextbox?.trim()) && Pattern.test(this.idText.trim());
    }

    toggleList(index: number, event: Event) {
        event.stopPropagation();
        if (this.activeAccessList === index) {
            // Close the "Access" popup
            this.activeAccessList = null;
        } else {
            // Open the "Access" popup and close the "Actions" popup
            this.activeAccessList = index;
            this.activePopupIndex = null;
        }
    }

    editSite(group: any, modal: TemplateRef<any>) {
        this.errors = {};
        this.selectedGksIds = {};
        this.modalService.open(modal, { size: 'sm', windowClass: 'custom-modal-class-userGroup', backdrop: 'static', keyboard: false });
        this.disableForm = true;
        console.log('the groups are', group);
        this.idToSend = group.id;
        this.idText = group.recordId;
        this.descriptionText = group.description;
        this.gksnametextbox = group.name;
        this.gksType = group.isCompositeGks;
        console.log('the edit response check is', JSON.stringify(group.access));
        if (group.access) {
            const updatedUserGroups = renameKey(group.access);
            console.log('the updatedUserGroups are', updatedUserGroups);
            function renameKey(access: Array<{ id: any; lable: any }>): Array<{ userGroupId: any; name?: any }> {
                return access.map((item) => ({
                    userGroupId: item.id,
                    name: item.lable,
                }));
            }
            this.editListofUserGroup = [...updatedUserGroups];
            this.selectedUserGroup = updatedUserGroups;
        }
        console.log('the this.selectedUserGroup are', this.selectedUserGroup);

        const selectedIds = this.selectedUserGroup.map((item: { userGroupId: any }) => item.userGroupId);
        this.selectedGksIds = selectedIds;

        console.log('the this.selectedUserGroup are', this.selectedUserGroup);
    }

    editGks() {
        console.log('access after changing', this.editListofUserGroup, this.selectedGksIds);

        function compareArrays(fixedArray: Array<{ userGroupId: number }>, dynamicArray: Array<number>): Record<number, boolean> {
            const result: Record<number, boolean> = {};

            // Initialize result with fixed array elements as false
            fixedArray.forEach((item) => {
                result[item.userGroupId] = false;
            });

            // Update result based on dynamic array
            dynamicArray.forEach((id) => {
                result[id] = true; // If exists, update to true; if new, it gets added as true
            });

            return result;
        }

        // Execute function
        console.log(compareArrays(this.editListofUserGroup, this.selectedGksIds));
        const idObject = compareArrays(this.editListofUserGroup, this.selectedGksIds);

        // const idObject = [...this.editListofUserGroup?.map((item: { userGroupId: any; }) => item.userGroupId), ...this.selectedGksIds]
        // .reduce((acc: { [key: number]: boolean }, id: number) => {
        //   acc[id] = this.selectedGksIds.includes(id);
        //   return acc;
        // }, {});

        const payload = {
            id: this.idToSend,
            name: this.gksnametextbox,
            recordId: this.idText,
            description: this.descriptionText,
            assignedUserGroups: idObject,
            isCompositeGks: this.gksType,
        };
        console.log('payload are', payload);
        this.reposervice
            .updateExistingGks(payload)
            .pipe(
                catchError((error) => {
                    if (error.status === 400) {
                        // Handle 500 error specifically
                        this.toast.warning(error.error.message);
                    } else {
                        // Handle other errors
                        console.error('An error occurred:', error);
                    }
                    // Return an empty observable so the app doesn't break
                    return of(null);
                }),
            )
            .subscribe((data) => {
                if (data.code === 200) {
                    this.toast.success(data.message);
                    this.modalService.dismissAll();
                    // this.currentPage = 1;
                    this.searchSite = '';
                    this.displayRepoList();
                }
                //add condition for other codes
            });
    }
}
